import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Form,
  Alert,
  Spinner,
  InputGroup,
  DropdownDivider,
  Container,
  Row,
  Col,
} from "react-bootstrap";

import GeneralPublicForm from "./GeneralPublicForm";
import Stepper from "../../components/Stepper";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import moment from "moment";
import {
  IconArrowNarrowLeftDashed,
  IconArrowNarrowRightDashed,
} from "@tabler/icons-react";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import { format } from "date-fns";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ProductRmaDetails from "./ProductRmaDetails";
// import FileUpload from "../../components/Attachment/Attachment";
import FileUpload from "./Attachment/FilleUpload";
import PublicRmaNotes from "./PublicRmaNotes";
import PublicShippingDetails from "./PublicShippingDetails";
import VerifyForm from "./VerifyForm";
import auth_background from "../../assets/auth_background.webp";
import useIdleLogout from "../../hooks/useIdleLogout";
import { trimTrailingZeros } from "../../utils/_helpers";

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

const PORT = process.env.REACT_APP_BASE_URL;

function CreatePublicRma() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [initialVal, setInitialVal] = useState(1);
  const [serverErr, setServerErr] = useState([]);
  const [show, setShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [rmaDataFetched, setRmaDataFetched] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [rfqDataFetchedcopy, setRfqDataFetchedcopy] = useState(false);
  const [formId, setFormId] = useState(null);
  const [isVerified, setIsVerified] = useState(false); // Step 1: State to track verification
  const [singleRmaQuantity, setSingleRmaQuantity] = useState([]);
  // const [verifiedOrderId, setVerifiedOrderId] = useState("");
  const [verifiedOrderData, setVerifiedOrderData] = useState({});

  const [searchDebounce, setSearchDebounce] = useState({
    searchName: "",
    searchEmail: "",
  });
  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });

  useIdleLogout();
  console.log("singleRmaQuantity", singleRmaQuantity);
  const [rfqstatus, setRfqStatus] = useState();

  const handleStatusChange = (event) => {
    setRfqStatus(event.target.value);
  };

  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const { rma_id } = useParams();

  const schema = yup.object().shape({
    notes: yup.array().of(
      yup.object().shape({
        section: yup.string().required("Section is required"),
        notesdata: yup.array().of(
          yup.object().shape({
            note: yup.string().required("Note cannot be blank"),
          })
        ),
      })
    ),

    // step 1
    rma_id: yup.string().required("RMA ID is required"),
    manufacturer_id: yup.string().required("Manufacturer's RMA ID is required"),
    publishedDate: yup.date().required("Published Date is required"),
    estimatedDate: yup.date().required("Estimated Return Date is required"),
    actualDate: yup.date().required("Actual Return Date is required"),
    // actualDate: yup.date().optional(),
    orderId: yup.string().required("Order ID is required"),
    organization_name: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(2, "Must be at least 2 character")
      .max(100, "Must be at most 100 characters"),

    rma_Description: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(5, "Must be at least 5 characters")
      .max(500, "Must be at most 500 characters"),

    // step 2
    trackingID: yup
      .string()
      .nullable()
      .test(
        "minLength",
        "Tracking ID must be at least 5 characters",
        function (value) {
          if (value === null || value === "") return true; // Allow nullable or empty
          return value.length >= 5;
        }
      ),

    shipping_method: yup.string().optional(),
    shipping_method_detail: yup.string().optional(),
    contractOfficerName: yup.string().optional(),
    contractOfficerEmail: yup
      .string()
      .optional()
      .email("Email must be a valid email address"),
    contractOfficerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // contractOfficerPhone: yup
    //   .string()
    //   .transform((value) => (value === "" ? null : value))
    //   .nullable()
    //   .test("valid-phone", "Invalid phone number", (value) => {
    //     if (!value) {
    //       return true;
    //     }
    //     if (typeof value === "string" && value.trim() !== "") {
    //       return isValidPhoneNumber(value);
    //     }

    //     return false;
    //   })
    //   .optional(),
    contractOfficerAddress: yup.string().optional(),

    shippingCustomerName: yup.string().optional(),
    shippingCustomerEmail: yup
      .string()
      .optional()
      .email("Email must be a valid email address"),
    shippingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // shippingCustomerPhone: yup
    //   .string()
    //   .transform((value) => (value === "" ? null : value))
    //   .nullable()
    //   .test("valid-phone", "Invalid phone number", (value) => {
    //     if (!value) {
    //       return true;
    //     }
    //     if (typeof value === "string" && value.trim() !== "") {
    //       return isValidPhoneNumber(value);
    //     }
    //     return false;
    //   })
    //   .optional(),
    shippingCustomerAddress: yup.string().optional(),

    // step 3
    products: yup.array().of(
      yup.object().shape({
        refund_qty: yup
          .number()
          .transform((value, originalValue) =>
            originalValue === "" ? undefined : value
          )
          .test(
            "refund-less-than-qty",
            "Return quantity cannot exceed quantity.",
            function (refund_qty) {
              const { qty } = this.parent;
              // Skip validation if refund_qty is empty or undefined
              if (refund_qty == null) return true;
              return refund_qty <= qty;
            }
          ),
      })
    ),
  });

  const transformData = (resData) => {
    return {
      notes: resData.map((section) => ({
        section: section.name,
        custom_id: section.custom_id,
        notesdata: section.notes.map((noteItem) => ({
          note: noteItem.note,
          user: noteItem.User.username,
          updateAt: noteItem.updated_at,
          custom_id: noteItem.custom_id || undefined,
        })),
      })),
    };
  };

  const onSingleNotesSuccess = (res) => {
    if (res?.data) {
      const transformedData = transformData(res.data);
      setValue("notes", transformedData.notes);
    }
  };

  // const onOrderIdError = (err) => {
  //   reset({
  //     OrderID: getValues("orderId"),
  //   });
  //   console.log("error", err);
  //   toast.error("The order with this Order ID does not exist.");
  //   setValue("orderId", "");
  // };

  // const onOrderIdSuccess = (res) => {
  //   if (res?.data) {
  //     if (res?.data?.status !== "PAID_CLOSED") {
  //       toast.error(
  //         "The order with this Order ID is either not yet completed or does not exist."
  //       );
  //       setValue("orderId", "");
  //       setValue("trackingID", "");
  //       setValue("rmaType", "");
  //       setValue("manufacturer_id", null);
  //       setValue("organization_name", "");
  //       setValue("estimatedDate", null);
  //       setValue("actualDate", null);
  //       setValue("rma_Description", "");
  //       return;
  //     }
  //     setValue("orderId", res?.data?.order_id ? res?.data?.order_id : null);
  //     // setValue("rma_id", res?.data?.rma_id ? res?.data?.rma_id : null);
  //     setValue(
  //       "trackingID",
  //       res?.data?.tracking_number ? res?.data?.tracking_number : null
  //     );
  //     setValue("rmaType", res?.data?.rma_type ? res?.data?.rma_type : "");
  //     setValue(
  //       "manufacturer_id",
  //       res?.data?.manufacturer_id ? res?.data?.manufacturer_id : null
  //     );
  //     setValue(
  //       "organization_name",
  //       res?.data?.organization_name ? res?.data?.organization_name : ""
  //     );
  //     setValue(
  //       "estimatedDate",
  //       res?.data?.estimated_date
  //         ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
  //         : null
  //     );
  //     setValue(
  //       "actualDate",
  //       res?.data?.actual_date
  //         ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
  //         : null
  //     );
  //     setValue("rma_Description", res?.data?.brief);

  //     setValue(
  //       "shipping_method",
  //       res?.data?.shipping_method ? res?.data?.shipping_method : ""
  //     );
  //     setValue(
  //       "shipping_method_detail",
  //       res?.data?.shipping_method_detail
  //         ? res?.data?.shipping_method_detail
  //         : ""
  //     );
  //     setValue(
  //       "contractOfficerName",
  //       res?.data?.orderKo?.name ? res?.data?.orderKo?.name : ""
  //     );
  //     setValue(
  //       "contractOfficerEmail",
  //       res?.data?.orderKo?.email ? res?.data?.orderKo?.email : ""
  //     );
  //     setValue(
  //       "contractOfficerPhone",
  //       res?.data?.orderKo?.phone ? res?.data?.orderKo?.phone : ""
  //     );
  //     setValue(
  //       "contractOfficerAddress",
  //       res?.data?.orderKo?.address ? res?.data?.orderKo?.address : ""
  //     );

  //     setValue(
  //       "shippingCustomerName",
  //       res?.data?.orderShipping?.name ? res?.data?.orderShipping?.name : ""
  //     );
  //     setValue(
  //       "shippingCustomerPhone",
  //       res?.data?.orderShipping?.phone ? res?.data?.orderShipping?.phone : ""
  //     );
  //     setValue(
  //       "shippingCustomerEmail",
  //       res?.data?.orderShipping?.email ? res?.data?.orderShipping?.email : ""
  //     );
  //     setValue(
  //       "shippingCustomerAddress",
  //       res?.data?.orderShipping?.address
  //         ? res?.data?.orderShipping?.address
  //         : ""
  //     );
  //     setValue("qty", res?.data?.OrderProducts?.[0]?.quantity || 0);
  //     setValue(
  //       "vendorName",
  //       res?.data?.OrderProducts?.[0]?.Vendor?.display_name || ""
  //     );
  //     setValue(
  //       "sameShipNameasKO",
  //       res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : ""
  //     );
  //     // setValue("invoice_no", res?.data?.OrderProducts?.[0]?.sku_id || "");
  //     // setValue("prod_desc", res?.data?.OrderProducts?.[0]?.description || "");
  //     // setValue("sku_price", res?.data?.OrderProducts?.[0]?.total_price || "");
  //     res?.data?.OrderProducts?.forEach((product, index) => {
  //       setValue(
  //         `products[${index}].vendorName`,
  //         product?.Vendor?.display_name || ""
  //       );
  //       setValue(`products[${index}].invoice_no`, product?.sku_id || "");
  //       setValue(`products[${index}].prod_desc`, product?.description || "");
  //       setValue(`products[${index}].qty`, product?.quantity || "");
  //       setValue(`products[${index}].sku_price`, product?.total_price || "");
  //       setValue(`products[${index}].autoId`, product?.auto_id || "");
  //     });
  //     // setAutoId(
  //     //   res?.data?.OrderProducts?.map((product) => product?.auto_id || "")
  //     // );
  //     setValue(
  //       "totalCostBeforeMargin",
  //       res?.data?.total_cost_before_margin
  //         ? res?.data?.total_cost_before_margin
  //         : null
  //     );
  //     setValue(
  //       "totalCostAfterMargin",
  //       res?.data?.total_cost_after_margin
  //         ? res?.data?.total_cost_after_margin
  //         : null
  //     );
  //   }
  // };

  const onOrderIdSuccessRma = (res) => {
    setOrderData(res?.data);
  };

  const { data: rma, postData: fetchSingleRma } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_PUBLICRMA
  );

  const { postData: verifyOrder } = usePostRequest(API_ENDPOINTS.VERIFY_ORDER);

  const { data: notesData, postData: fetchNotes } = usePostRequest(
    API_ENDPOINTS.GET_NOTES
  );

  const { data: databyOrderId, postData: fetchDataByOrderID } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_ORDER
  );

  const steps = ["General", "Billing & Shipping", "Products", "Attachments"];

  const onSingleRmaSuccess = (res) => {
    if (res?.data) {
      setValue("orderId", res?.data?.order_id ? res?.data?.order_id : "");
      setValue("rma_id", res?.data?.rma_id ? res?.data?.rma_id : null);
      setValue(
        "manufacturer_id",
        res?.data?.manufacturer_id ? res?.data?.manufacturer_id : null
      );
      setValue("rmaType", res?.data?.rma_type ? res?.data?.rma_type : "");
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : ""
      );
      setValue("rma_Description", res?.data?.brief);
      setValue(
        "publishedDate",
        res?.data?.published_date
          ? moment(res?.data?.published_date).format("MM/DD/YYYY")
          : null
      );
      setValue(
        "actualDate",
        res?.data?.actual_date
          ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
          : null
      );
      setValue(
        "estimatedDate",
        res?.data?.estimated_date
          ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
          : null
      );
      setValue(
        "estimateddelivery",
        res?.data?.estimated_delivery ? res?.data?.estimated_delivery : ""
      );
      setValue(
        "payment_terms",
        res?.data?.payment_term ? res?.data?.payment_term : ""
      );
      if (res?.data?.attachment_id) {
        setFormId(res?.data?.attachment_id);
      }
      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : ""
      );
      setValue(
        "shipping_method_detail",
        res?.data?.shipping_method_detail
          ? res?.data?.shipping_method_detail
          : ""
      );
      setValue(
        "shipping_terms",
        res?.data?.shipping_term ? res?.data?.shipping_term : ""
      );
      setValue(
        "contractOfficerName",
        res?.data?.rmaKo?.name ? res?.data?.rmaKo?.name : ""
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.rmaKo?.email ? res?.data?.rmaKo?.email : ""
      );
      setValue(
        "contractOfficerPhone",
        res?.data?.rmaKo?.phone ? res?.data?.rmaKo?.phone : ""
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.rmaKo?.address ? res?.data?.rmaKo?.address : ""
      );
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : ""
      );
      setValue(
        "shippingCustomerName",
        res?.data?.rmaShipping?.name ? res?.data?.rmaShipping?.name : ""
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.rmaShipping?.email ? res?.data?.rmaShipping?.email : ""
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.rmaShipping?.phone ? res?.data?.rmaShipping?.phone : ""
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.rmaShipping?.address ? res?.data?.rmaShipping?.address : ""
      );

      setSingleRmaQuantity(res?.data?.RmaProducts || []);

      setInitialVal(0);

      fetchDataByOrderID(
        { order_id: res?.data?.order_id },
        onOrderIdSuccessRma
      );
    }
  };

  const [currentStep, setCurrentStep] = useState(1);

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {},
  });

  const {
    handleSubmit,
    setError,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = methods;

  console.log("errors", errors);

  const onError = (error) => {
    if (error?.errors) {
      const updatedErrors = {};
      Object.keys(error.errors).forEach((field) => {
        if (error.errors[field]?.message) {
          updatedErrors[field] = {
            message: error.errors[field]?.message,
          };
        }
      });

      setServerErr((prevState) => ({
        ...prevState,
        ...updatedErrors,
      }));
      setShow(true);
    }
    toast.error(error?.message);
  };

  const { isLoading: createLoading, postData: createRMA } = usePostRequest(
    API_ENDPOINTS.CREATE_PUBLICRMA
  );

  const { isLoading: notesLoading, postData: createNotes } = usePostRequest(
    API_ENDPOINTS.CREATE_NOTES_PUBLICRMA
  );

  const { isLoading: UpdateLoading, postData: updateRMA } = usePostRequest(
    API_ENDPOINTS.UPDATE_PUBLICRMA
  );

  const formatPhone = (phone) => {
    if (!phone) return null;

    // Check if phone starts with '+'
    const startsWithPlus = phone.startsWith("+");

    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, "");

    // Add '+' back if it was there
    return startsWithPlus ? `+${cleaned}` : cleaned ? cleaned : null;
  };

  const onSubmit = (data) => {
    const isUpdate = rma && rma_id;

    const transformedProducts = data?.products?.map((product) => {
      // console.log("inner",product)
      const matchedItem = singleRmaQuantity.find(
        (item) => item.order_product_ref === product.autoId
      );

      const baseProduct = {
        vendor_name: product?.vendorName || null,
        sku_id: product?.invoice_no || null,
        description: product?.prod_desc || null,
        quantity: product?.qty ? Number(product?.qty) : 0,
        total_price: product?.sku_price ? Number(product?.sku_price) : 0,
        return_quantity:
          product?.refund_qty !== undefined ? Number(product?.refund_qty) : 0,
        auto_id: product?.autoId || null,
      };
      if (isUpdate) {
        return {
          ...baseProduct,
          old_quantity: matchedItem.quantity || 0, // or however you determine the old value
        };
      }

      return baseProduct;
    });

    const payload = {
      rma_id: data?.rma_id ? data?.rma_id : null,
      manufacturer_id: data?.manufacturer_id ? data?.manufacturer_id : null,
      rma_type: data?.rmaType ? data?.rmaType : null,
      order_id: data?.orderId ? data?.orderId : null,
      published_date: moment(data?.publishedDate).format("YYYY-MM-DD"),
      estimated_date: moment(data?.estimatedDate).format("YYYY-MM-DD"),
      actual_date: moment(data?.actualDate).format("YYYY-MM-DD"),
      organization_name: data?.organization_name
        ? data?.organization_name
        : null,
      brief: data?.rma_Description ? data?.rma_Description : null,
      tracking_number: data?.trackingID ? data?.trackingID : null,
      shipping_method: data?.shipping_method ? data?.shipping_method : null,
      shipping_method_detail: data?.shipping_method_detail
        ? data?.shipping_method_detail
        : null,
      ko_detail: {
        name: data?.contractOfficerName ? data?.contractOfficerName : null,
        email: data?.contractOfficerEmail ? data?.contractOfficerEmail : null,
        // phone: data?.contractOfficerPhone ? data?.contractOfficerPhone : null,
        phone: formatPhone(data?.contractOfficerPhone),
        address: data?.contractOfficerAddress
          ? data?.contractOfficerAddress
          : null,
      },
      shipping_detail: {
        name: data?.shippingCustomerName ? data?.shippingCustomerName : null,
        email: data?.shippingCustomerEmail ? data?.shippingCustomerEmail : null,
        // phone: data?.shippingCustomerPhone ? data?.shippingCustomerPhone : null,
        phone: formatPhone(data?.shippingCustomerPhone),
        address: data?.shippingCustomerAddress
          ? data?.shippingCustomerAddress
          : null,
      },
      products: [...transformedProducts],
      attachment_id: formId,
      total_cost_after_margin: data?.totalCostAfterMargin
        ? Number(data?.totalCostAfterMargin)
        : null,
    };

    const onSuccess = (res) => {
      const notesPayload = {
        module_id: res?.rma_id,
        module_type: "RMA",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }
      setIsModalOpen({
        show: true,
        title: "RMA Created Successfully!",
        message: `Prepared by CUSTOMER. RMA ID is ${res.rma_id}.
         Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    const onSuccessUpdate = (res) => {
      const notesPayload = {
        module_id: res?.rma_id,
        module_type: "RMA",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }
      setIsModalOpen({
        show: true,
        title: "RMA Updated Successfully!",
        message: `Updated by ${user?.username}. RMA ID is ${res.rma_id}.
        Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    if (rma && rma_id) {
      updateRMA(payload, onSuccessUpdate, onError);
    } else {
      createRMA(payload, onSuccess, onError, API_ENDPOINTS.CREATE_PUBLICRMA);
    }
  };

  useEffect(() => {
    if (rma_id && !rmaDataFetched) {
      fetchSingleRma({ rma_id }, onSingleRmaSuccess);
      setRmaDataFetched(true);
      setIsEditing(true);
    } else {
      setInitialVal(0);
    }
  }, [rma_id, rmaDataFetched, fetchSingleRma]);

  useEffect(() => {
    if (rma_id && !rmaDataFetched) {
      fetchNotes(
        {
          module_id: rma_id,
          module_type: "RMA",
        },
        onSingleNotesSuccess
      );
    }
  }, [rma_id, fetchNotes]);

  //   const handleOrderIDBlur = () => {
  //     const value = getValues("orderId");
  //     if (value.length > 0) {
  //       fetchDataByOrderID({ order_id: value }, onOrderIdSuccess, onOrderIdError);
  //     }
  //   };

  // useEffect(() => {
  //   const value = getValues("orderId");
  //   if (value && value.length > 0) {
  //     fetchDataByOrderID({ order_id: value }, onOrderIdSuccess, onOrderIdError);
  //   }
  // }, [getValues, fetchDataByOrderID]);

  useEffect(() => {
    if (!verifiedOrderData || Object.keys(verifiedOrderData).length === 0)
      return;

    setValue("orderId", verifiedOrderData.order_id || null);
    setValue("trackingID", verifiedOrderData.tracking_number || null);
    setValue("rmaType", verifiedOrderData.rma_type || "");
    setValue("manufacturer_id", verifiedOrderData.manufacturer_id || null);
    setValue("organization_name", verifiedOrderData.organization_name || "");
    setValue(
      "estimatedDate",
      verifiedOrderData.estimated_date
        ? moment(verifiedOrderData.estimated_date).format("MM/DD/YYYY")
        : null
    );
    setValue(
      "actualDate",
      verifiedOrderData.actual_date
        ? moment(verifiedOrderData.actual_date).format("MM/DD/YYYY")
        : null
    );
    setValue("rma_Description", verifiedOrderData.brief || "");

    setValue("shipping_method", verifiedOrderData.shipping_method || "");
    setValue(
      "shipping_method_detail",
      verifiedOrderData.shipping_method_detail || ""
    );

    setValue("contractOfficerName", verifiedOrderData.orderKo?.name || "");
    setValue("contractOfficerEmail", verifiedOrderData.orderKo?.email || "");
    setValue("contractOfficerPhone", verifiedOrderData.orderKo?.phone || "");
    setValue(
      "contractOfficerAddress",
      verifiedOrderData.orderKo?.address || ""
    );

    setValue(
      "shippingCustomerName",
      verifiedOrderData.orderShipping?.name || ""
    );
    setValue(
      "shippingCustomerPhone",
      verifiedOrderData.orderShipping?.phone || ""
    );
    setValue(
      "shippingCustomerEmail",
      verifiedOrderData.orderShipping?.email || ""
    );
    setValue(
      "shippingCustomerAddress",
      verifiedOrderData.orderShipping?.address || ""
    );

    const products = verifiedOrderData.OrderProductSales || [];

    setValue("qty", trimTrailingZeros(products[0]?.quantity) || 0);
    setValue("vendorName", products[0]?.Vendor?.display_name || "");
    setValue("sameShipNameasKO", verifiedOrderData.is_shipping_same_ko || "");

    products.forEach((product, index) => {
      setValue(
        `products[${index}].vendorName`,
        product?.Vendor?.display_name || ""
      );
      setValue(`products[${index}].invoice_no`, product?.sku_id || "");
      setValue(`products[${index}].prod_desc`, product?.description || "");
      setValue(`products[${index}].qty`, trimTrailingZeros(product?.quantity) || "");
      setValue(`products[${index}].sku_price`, product?.total_price || "");
      setValue(`products[${index}].autoId`, product?.auto_id || "");
    });

    setValue(
      "totalCostBeforeMargin",
      verifiedOrderData.total_cost_before_margin || null
    );
    setValue(
      "totalCostAfterMargin",
      verifiedOrderData.total_cost_after_margin || null
    );
  }, [verifiedOrderData, setValue]);

  const handleVerification = (isVerified, response) => {
    console.log("isVerfied", isVerified);
    if (isVerified) {
      setIsVerified(true);
      setCurrentStep(1);
      setVerifiedOrderData(response.data);
      // setVerifiedOrderId(response.data.order_id);
    } else {
      toast.error("Verification failed. Please check your credentials.");
    }
  };

  const handleStepChange = (type) => {
    if (type === "next") {
      const currentData = methods.getValues();

      console.log(currentData);

      const fieldsToValidate = getFieldsForCurrentStep(currentStep);
      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep((prev) => prev + 1);
        } else {
          console.log("Errors:", methods.formState.errors);
        }
      });
    } else {
      console.log("Errors:2", methods.formState.errors);
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleTabChange = (tabIndex) => {
    if (rma_id) {
      const fieldsToValidate = getFieldsForCurrentStep(currentStep);

      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep(tabIndex);
        } else {
          console.log("Validation failed for step:", currentStep);
        }
      });
    }
  };

  useEffect(() => {
    if (!rma_id) {
      reset();
      setCurrentStep(1);
    } else {
    }
  }, [rma_id, location.pathname]);

  const getFieldsForCurrentStep = (step, rma_id) => {
    switch (step) {
      case 1:
        return [
          "rma_id",
          "manufacturer_id",
          "organization_name",
          "rma_Description",
          "publishedDate",
          "estimatedDate",
          "actualDate",
          "orderId",
        ];
      case 2:
        return [
          // "shipping_method",
          "shipping_method_detail",

          "contractOfficerName",
          "contractOfficerEmail",
          "contractOfficerPhone",
          "contractOfficerAddress",

          "shippingCustomerName",
          "shippingCustomerEmail",
          "shippingCustomerPhone",
          "shippingCustomerAddress",
        ];
      case 3:
        return ["products"];
      case 4:
        return [];
      case 5:
        return ["notes"];
      default:
        return [];
    }
  };

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    reset();
  }, []);

  // console.log("the formId is ", formId);

  const rmaProductData = watch("products");

  console.log("the products are out ", singleRmaQuantity);
  console.log("rmaProductData", rmaProductData);

  if (rmaProductData) {
    console.log("the products are ", singleRmaQuantity);
    console.log("rmaProductData 2", rmaProductData);

    rmaProductData?.forEach((product, index) => {
      console.log("the prods are ", product);
      const matchedItem = singleRmaQuantity.find(
        (item) => item.order_product_ref === product?.autoId
      );
      console.log("matchedItem", matchedItem);

      if (matchedItem) {
        setValue(`products[${index}].refund_qty`, matchedItem.quantity || "");
      }
    });
  }

  /*useEffect(() => {
    
  }, [rmaProductData]);*/

  useEffect(() => {
    if (orderData) {
      orderData?.OrderProductSales?.map((product, index) => {
        const matched = singleRmaQuantity.find(
          (item) => Number(item.order_product_ref) === Number(product.auto_id)
        );
        console.log("data 1", product);
        console.log("data 2", matched);

        setValue(
          `products[${index}].vendorName`,
          product?.Vendor?.display_name || ""
        );
        setValue(`products[${index}].invoice_no`, product?.sku_id || "");
        setValue(`products[${index}].prod_desc`, product?.description || "");

        console.log(
          "aaa",
          Number(product?.quantity || 0) -
            Number(product?.return_quantity || 0) +
            Number(matched?.quantity || 0)
        );

        let matchedValue =
          Number(product?.quantity || 0) -
          Number(product?.return_quantity || 0) +
          Number(matched?.quantity || 0);

        setValue(`products[${index}].qty`, matchedValue);
        // setValue(`products[${index}].qty`, product?.quantity || "");
        setValue(`products[${index}].sku_price`, product?.total_price || "");
        setValue(`products[${index}].autoId`, product?.auto_id || "");
      });

      // setValue(
      //   "totalCostAfterMargin",
      //   res?.data?.total_cost_after_margin
      //     ? res?.data?.total_cost_after_margin
      //     : null
      // );
    }
  }, [orderData]);

  return (
    <>
      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() => {
          // setIsModalOpen({ ...isModalOpen, show: false });
          window.location.reload();
        }}
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
      />

      <div
        style={{
          backgroundImage: `url(${auth_background})`,
        }}
        className="full_modal_bg"
      >
        <Container>
          <Row className="justify-content-md-center">
            <Col md={12}>
              <Card>
                <Card.Header className="d-flex align-items-center justify-content-between p-4">
                  <h2 className="page-title">
                    {isVerified ? "Create RMA" : "Verify Your Details"}
                  </h2>
                </Card.Header>
                <Card.Body>
                  {!isVerified ? (
                    <VerifyForm onVerify={handleVerification} />
                  ) : (
                    <FormProvider {...methods}>
                      <>
                        <Stepper
                          steps={steps}
                          currentStep={currentStep}
                          onTabClick={rma_id ? handleTabChange : undefined}
                        />
                        <Form onSubmit={methods.handleSubmit(onSubmit)}>
                          {currentStep === 1 && (
                            <GeneralPublicForm
                              isEditing={isEditing}
                              //   onOrderIDBlur={handleOrderIDBlur}
                              orderId={verifiedOrderData}
                            />
                          )}
                          {currentStep === 2 && (
                            <PublicShippingDetails initialVal={initialVal} />
                          )}
                          {currentStep === 3 && <ProductRmaDetails />}
                          {currentStep === 4 && (
                            <FileUpload
                              moduleType={"RMA"}
                              attachmnetid={formId}
                            />
                          )}

                          {show && (
                            <Alert
                              variant="danger"
                              onClose={() => setShow(false)}
                              dismissible
                            >
                              <Alert.Heading>Validation Errors!</Alert.Heading>
                              {Object.keys(serverErr).map((field) => (
                                <p key={field} className="text-danger mb-1">
                                  {serverErr[field]?.message}
                                </p>
                              ))}
                            </Alert>
                          )}

                          <div className="d-flex justify-content-center gap-3 mt-3">
                            {currentStep > 1 && (
                              <Button
                                variant="outline-secondary"
                                onClick={() => handleStepChange("prev")}
                              >
                                <IconArrowNarrowLeftDashed /> Back
                              </Button>
                            )}
                            {currentStep < 4 && (
                              <Button
                                variant="warning"
                                onClick={() => handleStepChange("next")}
                              >
                                Next <IconArrowNarrowRightDashed />
                              </Button>
                            )}
                            {rma_id && currentStep < steps.length && (
                              <Button variant="warning" type="submit">
                                {createLoading || UpdateLoading ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  "Update"
                                )}
                              </Button>
                            )}
                            {currentStep === 4 && (
                              <Button variant="warning" type="submit">
                                {createLoading || UpdateLoading ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  "Submit"
                                )}
                              </Button>
                            )}
                          </div>
                        </Form>
                      </>
                    </FormProvider>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CreatePublicRma;
